import PageProtectedLayout from "../../../components/Page/PageProtectedLayout";
import BloodtestsPanel from "./BloodtestsPanel";
import { useTranslation } from '../../../language';

export default function BloodtestsWelcome() {

  const { t } = useTranslation();

  return (

    <PageProtectedLayout
      headline={t('page_hl_bloodtests')}
      specify={t('page_sp_bloodtests')}
      headlineNoWrap
    >

      {/* Main Page Content */}
      <BloodtestsPanel />

    </PageProtectedLayout>

  );
}
